
import { getAction, postAction } from "./http/manage";
const URL = process.env.VUE_APP_API_PREFIX;

// ��ѯӳ��
const querySoftWareMapList = (params) =>
    getAction(URL + "/softWare/querySoftWareMapList", params);
// �������ӳ��
const createSoftWareMap = (params) =>
    postAction(URL + "/softWare/createSoftWareMap", params);
// �༭���ӳ��
const updateSoftWareMap = (params) =>
    postAction(URL + "/softWare/updateSoftWareMap", params);
// ɾ��ɾ����Ϣ
const deleteSoftWareMap = (params) =>
    postAction(URL + "/softWare/deleteSoftWareMap?id=" + params.id);
// ��ѯӳ��
const querySoftMapList = () =>
    getAction(URL + "/softWare/querySoftMapInfo");
export {
    querySoftWareMapList,
    createSoftWareMap,
    updateSoftWareMap,
    deleteSoftWareMap,
    querySoftMapList,
};
